import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import email_Illustration from "../../assets/images/email_Illustration.png";
import { Link } from "react-router-dom";

const EmailSetup = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Email Setup" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Email Setup</p>
      </div>

      <div className="w-full flex flex-col justify-center items-center mt-16">
        <div>
          <img
            src={email_Illustration}
            alt="sms Illustration"
            className="w-52"
          />
        </div>
        <p className="text-[18px] font-bold mt-6">
          Start creating email Templates
        </p>
        <p className="text-[#979797] text-[16px] mt-6">
          You can create email Template for multiple tasks.
        </p>
        <Link
          to="/profile/select-template"
          className="mt-6 bg-[#2F80ED] py-3 px-4 text-white rounded-lg"
        >
          Start Creating
        </Link>
      </div>
    </div>
  );
};

export default EmailSetup;
